import comp from "./DisabledStateTooltip";
export default comp;
